export { buildCanonicalUrl } from './localeUrl';
